/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ModalRoot, { Modal, ModalBody, ModalHeader } from '../../../../components/Modal';
import { modalsScreensNames } from '../../constants';
import Details from './details';

const TransactionModal = ({ hide, ...props }) => {
  const [currentScreen, setCurrentScreen] = useState(modalsScreensNames.TRANSACTION_DETAILS);

  const interestPaymentFlow = useMemo(
    () => [
      {
        screen: modalsScreensNames.TRANSACTION_DETAILS,
        component: <Details openScreen={setCurrentScreen} hidePopup={hide} {...props} />,
      },
    ],
    [hide, props]
  );

  const SelectedComponent = useMemo(
    () => interestPaymentFlow.find((item) => item.screen === currentScreen).component,
    [interestPaymentFlow, currentScreen]
  );

  return (
    <ModalRoot>
      <Modal contentStyle={{ height: 'auto' }}>
        <ModalHeader>
          <i
            onClick={hide}
            onKeyDown={hide}
            role="button"
            className="close-btn cursor-pointer icon icon-close-other text-shadow"
            tabIndex={-1}
            aria-label="Close"
          />
        </ModalHeader>
        <ModalBody>{SelectedComponent}</ModalBody>
      </Modal>
    </ModalRoot>
  );
};

TransactionModal.propTypes = {
  hide: PropTypes.func,
};

export default TransactionModal;
